/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule} from '@angular/forms';

import template from './user-edit-roles-section.component.html';
import {APP_SHARED} from '../../common/app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED, FormsModule],
  selector: 'adn-user-edit-roles-section',
  template
})
export class UserEditRolesSectionComponent {
  @Input() application: string;
  @Input() viewOnly = false;
  @Input() blockFields = false;
  @Input() inNetwork = false;
  @Input() isNew = false;
  @Input() editingModel: any;
  @Input() networkRoles: any;
  @Input() roles: any;

  @Output() roleChanged = new EventEmitter<void>();

  compareRoles(a: any, b: any): boolean {
    if (a === b) {
      return true;
    }
    if (!a || !b) {
      return false;
    }
    return a.id === b.id;
  }

  getTeamRoles(teamType: string): any[] {
    const appRoles = this.roles?.[this.application];
    if (!appRoles) {
      return [];
    }
    if (teamType !== 'STANDARD' && appRoles[teamType]) {
      return appRoles[teamType];
    }
    return Array.isArray(appRoles) ? appRoles : [];
  }

  showTeamGroupsTable(): boolean {
    const role = this.editingModel?.networkGroup?.[this.application]?.role;
    if (!role) {
      return false;
    }
    const permissions = role.permissions || [];
    const hasManageSystem = permissions.indexOf('MANAGE_SYSTEM') > -1;
    const hasPoliticalAdmin = this.application === 'POLITICAL' && permissions.indexOf('POLITICAL_ADMIN') > -1;
    return (hasManageSystem || hasPoliticalAdmin) && (this.editingModel?.teamGroups || []).length > 0;
  }

  onNetworkRoleChange(): void {
    this.roleChanged.emit();
  }
}
